// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json = require("../../../shared/src/Json.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Apollo = require("../../../shared/src/bindings/Apollo.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var WebTypes_Shift = require("../types/WebTypes_Shift.bs.js");
var CommonTypes_Business_Id = require("../../../shared/src/types/business/CommonTypes_Business_Id.bs.js");
var CommonTypes_WorkerShift = require("../../../shared/src/types/CommonTypes_WorkerShift.bs.js");

var Raw = {};

var query = "query   {\ncurrentUser  {\nbusiness  {\nshifts(filter: {tipsPayoutType: {equalTo: TIPS_PAID_BY_QWICK}})  {\nnodes  {\n...WebTypes_Shift   \n}\n\n}\n\n}\n\n}\n\n}\n" + WebTypes_Shift.query;

function parse(value) {
  var value$1 = value.currentUser;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.business;
    var tmp$1;
    if (value$2 == null) {
      tmp$1 = undefined;
    } else {
      var value$3 = value$2.shifts;
      var value$4 = value$3.nodes;
      tmp$1 = {
        shifts: {
          nodes: value$4.map(function (value) {
                if (!(value == null)) {
                  return WebTypes_Shift.verifyArgsAndParse("WebTypes_Shift", value);
                }
                
              })
        }
      };
    }
    tmp = {
      business: tmp$1
    };
  }
  return {
          currentUser: tmp
        };
}

function serialize(value) {
  var value$1 = value.currentUser;
  var currentUser;
  if (value$1 !== undefined) {
    var value$2 = value$1.business;
    var business;
    if (value$2 !== undefined) {
      var value$3 = value$2.shifts;
      var value$4 = value$3.nodes;
      var nodes = value$4.map(function (value) {
            if (value !== undefined) {
              return WebTypes_Shift.serialize(value);
            } else {
              return null;
            }
          });
      var shifts = {
        nodes: nodes
      };
      business = {
        shifts: shifts
      };
    } else {
      business = null;
    }
    currentUser = {
      business: business
    };
  } else {
    currentUser = null;
  }
  return {
          currentUser: currentUser
        };
}

function serializeVariables(param) {
  
}

function makeVariables(param) {
  
}

function makeDefaultVariables(param) {
  
}

function variables(param) {
  return Json.Encode.object_(/* [] */0);
}

function decode(param) {
  var match = param.currentUser;
  if (match === undefined) {
    return ;
  }
  var match$1 = match.business;
  if (match$1 !== undefined) {
    return Relude_Option.pure(Relude_Array.mapOption(Curry._1(Relude_Option.flatMap, WebTypes_Shift.tToR), match$1.shifts.nodes));
  }
  
}

var Definition = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  makeDefaultVariables: makeDefaultVariables,
  variables: variables,
  decode: decode
};

var include = Apollo.CreateQuery({
      Raw: Raw,
      query: query,
      variables: variables,
      parse: parse,
      decode: decode
    });

var GetPayTipsToDos_graphqlQueryAST = include.graphqlQueryAST;

var GetPayTipsToDos_query = include.query;

var GetPayTipsToDos_queryStoreError = include.queryStoreError;

var GetPayTipsToDos_queryResult = include.queryResult;

var GetPayTipsToDos_queryAsyncData = include.queryAsyncData;

var GetPayTipsToDos_queryAsyncDataStoreError = include.queryAsyncDataStoreError;

var GetPayTipsToDos_queryAsyncResult = include.queryAsyncResult;

var GetPayTipsToDos = {
  Definition: Definition,
  graphqlQueryAST: GetPayTipsToDos_graphqlQueryAST,
  query: GetPayTipsToDos_query,
  queryStoreError: GetPayTipsToDos_queryStoreError,
  queryResult: GetPayTipsToDos_queryResult,
  queryAsyncData: GetPayTipsToDos_queryAsyncData,
  queryAsyncDataStoreError: GetPayTipsToDos_queryAsyncDataStoreError,
  queryAsyncResult: GetPayTipsToDos_queryAsyncResult
};

var Raw$1 = {};

var query$1 = "mutation businessPayTipsForWorkerShifts($payWorkerShiftTips: [PayWorkerShiftTipsInputRecordInput]!)  {\nbusinessPayTipsForWorkerShifts(input: {payWorkerShiftTips: $payWorkerShiftTips})  {\nworkerShifts  {\nshift  {\n...WebTypes_Shift   \n}\n\n}\n\n}\n\n}\n" + WebTypes_Shift.query;

function parse$1(value) {
  var value$1 = value.businessPayTipsForWorkerShifts;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.workerShifts;
    tmp = {
      workerShifts: !(value$2 == null) ? value$2.map(function (value) {
              if (value == null) {
                return ;
              }
              var value$1 = value.shift;
              return {
                      shift: WebTypes_Shift.verifyArgsAndParse("WebTypes_Shift", value$1)
                    };
            }) : undefined
    };
  }
  return {
          businessPayTipsForWorkerShifts: tmp
        };
}

function serialize$1(value) {
  var value$1 = value.businessPayTipsForWorkerShifts;
  var businessPayTipsForWorkerShifts;
  if (value$1 !== undefined) {
    var value$2 = value$1.workerShifts;
    var workerShifts = value$2 !== undefined ? value$2.map(function (value) {
            if (value === undefined) {
              return null;
            }
            var value$1 = value.shift;
            var shift = WebTypes_Shift.serialize(value$1);
            return {
                    shift: shift
                  };
          }) : null;
    businessPayTipsForWorkerShifts = {
      workerShifts: workerShifts
    };
  } else {
    businessPayTipsForWorkerShifts = null;
  }
  return {
          businessPayTipsForWorkerShifts: businessPayTipsForWorkerShifts
        };
}

function serializeInputObjectPayWorkerShiftTipsInputRecordInput(inp) {
  var a = inp.amountCents;
  var a$1 = inp.workerShiftId;
  return {
          amountCents: a !== undefined ? a : undefined,
          workerShiftId: a$1 !== undefined ? Caml_option.valFromOption(a$1) : undefined
        };
}

function serializeVariables$1(inp) {
  var a = inp.payWorkerShiftTips;
  return {
          payWorkerShiftTips: a.map(function (b) {
                if (b !== undefined) {
                  return serializeInputObjectPayWorkerShiftTipsInputRecordInput(b);
                }
                
              })
        };
}

function makeVariables$1(payWorkerShiftTips, param) {
  return {
          payWorkerShiftTips: payWorkerShiftTips
        };
}

function makeInputObjectPayWorkerShiftTipsInputRecordInput(amountCents, workerShiftId, param) {
  return {
          amountCents: amountCents,
          workerShiftId: workerShiftId
        };
}

function variables$1(payTips) {
  return Json.Encode.object_({
              hd: [
                "payWorkerShiftTips",
                Json.Encode.array(CommonTypes_WorkerShift.PayTipsInput.encode)(payTips)
              ],
              tl: /* [] */0
            });
}

function decode$1(param) {
  var match = param.businessPayTipsForWorkerShifts;
  if (match === undefined) {
    return ;
  }
  var workerShifts = match.workerShifts;
  if (workerShifts !== undefined) {
    return Relude_Option.pure(Relude_Array.mapOption(Curry._1(Relude_Option.flatMap, (function (param) {
                          return WebTypes_Shift.tToR(param.shift);
                        })), workerShifts));
  }
  
}

var Definition$1 = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectPayWorkerShiftTipsInputRecordInput: serializeInputObjectPayWorkerShiftTipsInputRecordInput,
  makeVariables: makeVariables$1,
  makeInputObjectPayWorkerShiftTipsInputRecordInput: makeInputObjectPayWorkerShiftTipsInputRecordInput,
  variables: variables$1,
  decode: decode$1
};

var include$1 = Apollo.CreateMutation({
      Raw: Raw$1,
      query: query$1,
      variables: variables$1,
      parse: parse$1,
      decode: decode$1
    });

var PayTips_graphqlMutationAST = include$1.graphqlMutationAST;

var PayTips_mutate = include$1.mutate;

var PayTips_mutateStoreError = include$1.mutateStoreError;

var PayTips_mutateResult = include$1.mutateResult;

var PayTips_mutateResultStore = include$1.mutateResultStore;

var PayTips_mutateAsyncData = include$1.mutateAsyncData;

var PayTips_mutateAsyncResult = include$1.mutateAsyncResult;

var PayTips_mutateAsycResultApolloError = include$1.mutateAsycResultApolloError;

var PayTips = {
  Definition: Definition$1,
  graphqlMutationAST: PayTips_graphqlMutationAST,
  mutate: PayTips_mutate,
  mutateStoreError: PayTips_mutateStoreError,
  mutateResult: PayTips_mutateResult,
  mutateResultStore: PayTips_mutateResultStore,
  mutateAsyncData: PayTips_mutateAsyncData,
  mutateAsyncResult: PayTips_mutateAsyncResult,
  mutateAsycResultApolloError: PayTips_mutateAsycResultApolloError
};

var Raw$2 = {};

var query$2 = "subscription shiftCreatedByBusiness($businessId: BigInt!)  {\nshiftCreatedByBusiness(businessId: $businessId)  {\nshift  {\n...WebTypes_Shift   \n}\n\n}\n\n}\n" + WebTypes_Shift.query;

function parse$2(value) {
  var value$1 = value.shiftCreatedByBusiness;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.shift;
    tmp = {
      shift: !(value$2 == null) ? WebTypes_Shift.verifyArgsAndParse("WebTypes_Shift", value$2) : undefined
    };
  }
  return {
          shiftCreatedByBusiness: tmp
        };
}

function serialize$2(value) {
  var value$1 = value.shiftCreatedByBusiness;
  var shiftCreatedByBusiness;
  if (value$1 !== undefined) {
    var value$2 = value$1.shift;
    var shift = value$2 !== undefined ? WebTypes_Shift.serialize(value$2) : null;
    shiftCreatedByBusiness = {
      shift: shift
    };
  } else {
    shiftCreatedByBusiness = null;
  }
  return {
          shiftCreatedByBusiness: shiftCreatedByBusiness
        };
}

function serializeVariables$2(inp) {
  return {
          businessId: inp.businessId
        };
}

function makeVariables$2(businessId, param) {
  return {
          businessId: businessId
        };
}

function variables$2(id) {
  return Json.Encode.object_({
              hd: [
                "businessId",
                Curry._1(CommonTypes_Business_Id.encode, id)
              ],
              tl: /* [] */0
            });
}

function decode$2(param) {
  var match = param.shiftCreatedByBusiness;
  if (match !== undefined) {
    return Curry._2(Relude_Option.flatMap, WebTypes_Shift.tToR, match.shift);
  }
  
}

var Definition$2 = {
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  makeVariables: makeVariables$2,
  variables: variables$2,
  decode: decode$2
};

var include$2 = Apollo.CreateSubscription({
      Raw: Raw$2,
      query: query$2,
      variables: variables$2,
      parse: parse$2,
      decode: decode$2
    });

var ShiftCreated_graphQLSubscriptionAST = include$2.graphQLSubscriptionAST;

var ShiftCreated_subscribe = include$2.subscribe;

var ShiftCreated = {
  Definition: Definition$2,
  graphQLSubscriptionAST: ShiftCreated_graphQLSubscriptionAST,
  subscribe: ShiftCreated_subscribe
};

var Raw$3 = {};

var query$3 = "subscription shiftUpdatedByBusiness($businessId: BigInt!)  {\nshiftUpdatedByBusiness(businessId: $businessId)  {\nshift  {\n...WebTypes_Shift   \n}\n\n}\n\n}\n" + WebTypes_Shift.query;

function parse$3(value) {
  var value$1 = value.shiftUpdatedByBusiness;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.shift;
    tmp = {
      shift: !(value$2 == null) ? WebTypes_Shift.verifyArgsAndParse("WebTypes_Shift", value$2) : undefined
    };
  }
  return {
          shiftUpdatedByBusiness: tmp
        };
}

function serialize$3(value) {
  var value$1 = value.shiftUpdatedByBusiness;
  var shiftUpdatedByBusiness;
  if (value$1 !== undefined) {
    var value$2 = value$1.shift;
    var shift = value$2 !== undefined ? WebTypes_Shift.serialize(value$2) : null;
    shiftUpdatedByBusiness = {
      shift: shift
    };
  } else {
    shiftUpdatedByBusiness = null;
  }
  return {
          shiftUpdatedByBusiness: shiftUpdatedByBusiness
        };
}

function serializeVariables$3(inp) {
  return {
          businessId: inp.businessId
        };
}

function makeVariables$3(businessId, param) {
  return {
          businessId: businessId
        };
}

function variables$3(id) {
  return Json.Encode.object_({
              hd: [
                "businessId",
                Curry._1(CommonTypes_Business_Id.encode, id)
              ],
              tl: /* [] */0
            });
}

function decode$3(param) {
  var match = param.shiftUpdatedByBusiness;
  if (match !== undefined) {
    return Curry._2(Relude_Option.flatMap, WebTypes_Shift.tToR, match.shift);
  }
  
}

var Definition$3 = {
  Raw: Raw$3,
  query: query$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables$3,
  makeVariables: makeVariables$3,
  variables: variables$3,
  decode: decode$3
};

var include$3 = Apollo.CreateSubscription({
      Raw: Raw$3,
      query: query$3,
      variables: variables$3,
      parse: parse$3,
      decode: decode$3
    });

var ShiftUpdated_graphQLSubscriptionAST = include$3.graphQLSubscriptionAST;

var ShiftUpdated_subscribe = include$3.subscribe;

var ShiftUpdated = {
  Definition: Definition$3,
  graphQLSubscriptionAST: ShiftUpdated_graphQLSubscriptionAST,
  subscribe: ShiftUpdated_subscribe
};

var Raw$4 = {};

var query$4 = "subscription workerShiftCreated($businessId: BigInt!)  {\nworkerShiftCreatedByBusiness(businessId: $businessId)  {\nworkerShift  {\nid  \nshift  {\n...WebTypes_Shift   \n}\n\n}\n\n}\n\n}\n" + WebTypes_Shift.query;

function parse$4(value) {
  var value$1 = value.workerShiftCreatedByBusiness;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.workerShift;
    var tmp$1;
    if (value$2 == null) {
      tmp$1 = undefined;
    } else {
      var value$3 = value$2.shift;
      tmp$1 = {
        id: value$2.id,
        shift: WebTypes_Shift.verifyArgsAndParse("WebTypes_Shift", value$3)
      };
    }
    tmp = {
      workerShift: tmp$1
    };
  }
  return {
          workerShiftCreatedByBusiness: tmp
        };
}

function serialize$4(value) {
  var value$1 = value.workerShiftCreatedByBusiness;
  var workerShiftCreatedByBusiness;
  if (value$1 !== undefined) {
    var value$2 = value$1.workerShift;
    var workerShift;
    if (value$2 !== undefined) {
      var value$3 = value$2.shift;
      var shift = WebTypes_Shift.serialize(value$3);
      var value$4 = value$2.id;
      workerShift = {
        id: value$4,
        shift: shift
      };
    } else {
      workerShift = null;
    }
    workerShiftCreatedByBusiness = {
      workerShift: workerShift
    };
  } else {
    workerShiftCreatedByBusiness = null;
  }
  return {
          workerShiftCreatedByBusiness: workerShiftCreatedByBusiness
        };
}

function serializeVariables$4(inp) {
  return {
          businessId: inp.businessId
        };
}

function makeVariables$4(businessId, param) {
  return {
          businessId: businessId
        };
}

function variables$4(id) {
  return Json.Encode.object_({
              hd: [
                "businessId",
                Curry._1(CommonTypes_Business_Id.encode, id)
              ],
              tl: /* [] */0
            });
}

function decode$4(param) {
  var match = param.workerShiftCreatedByBusiness;
  if (match === undefined) {
    return ;
  }
  var match$1 = match.workerShift;
  if (match$1 !== undefined) {
    return WebTypes_Shift.tToR(match$1.shift);
  }
  
}

var Definition$4 = {
  Raw: Raw$4,
  query: query$4,
  parse: parse$4,
  serialize: serialize$4,
  serializeVariables: serializeVariables$4,
  makeVariables: makeVariables$4,
  variables: variables$4,
  decode: decode$4
};

var include$4 = Apollo.CreateSubscription({
      Raw: Raw$4,
      query: query$4,
      variables: variables$4,
      parse: parse$4,
      decode: decode$4
    });

var WorkerShiftCreated_graphQLSubscriptionAST = include$4.graphQLSubscriptionAST;

var WorkerShiftCreated_subscribe = include$4.subscribe;

var WorkerShiftCreated = {
  Definition: Definition$4,
  graphQLSubscriptionAST: WorkerShiftCreated_graphQLSubscriptionAST,
  subscribe: WorkerShiftCreated_subscribe
};

var Raw$5 = {};

var query$5 = "subscription workerShiftUpdated($businessId: BigInt!)  {\nworkerShiftUpdatedByBusiness(businessId: $businessId)  {\nworkerShift  {\nid  \nshift  {\n...WebTypes_Shift   \n}\n\n}\n\n}\n\n}\n" + WebTypes_Shift.query;

function parse$5(value) {
  var value$1 = value.workerShiftUpdatedByBusiness;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.workerShift;
    var tmp$1;
    if (value$2 == null) {
      tmp$1 = undefined;
    } else {
      var value$3 = value$2.shift;
      tmp$1 = {
        id: value$2.id,
        shift: WebTypes_Shift.verifyArgsAndParse("WebTypes_Shift", value$3)
      };
    }
    tmp = {
      workerShift: tmp$1
    };
  }
  return {
          workerShiftUpdatedByBusiness: tmp
        };
}

function serialize$5(value) {
  var value$1 = value.workerShiftUpdatedByBusiness;
  var workerShiftUpdatedByBusiness;
  if (value$1 !== undefined) {
    var value$2 = value$1.workerShift;
    var workerShift;
    if (value$2 !== undefined) {
      var value$3 = value$2.shift;
      var shift = WebTypes_Shift.serialize(value$3);
      var value$4 = value$2.id;
      workerShift = {
        id: value$4,
        shift: shift
      };
    } else {
      workerShift = null;
    }
    workerShiftUpdatedByBusiness = {
      workerShift: workerShift
    };
  } else {
    workerShiftUpdatedByBusiness = null;
  }
  return {
          workerShiftUpdatedByBusiness: workerShiftUpdatedByBusiness
        };
}

function serializeVariables$5(inp) {
  return {
          businessId: inp.businessId
        };
}

function makeVariables$5(businessId, param) {
  return {
          businessId: businessId
        };
}

function variables$5(id) {
  return Json.Encode.object_({
              hd: [
                "businessId",
                Curry._1(CommonTypes_Business_Id.encode, id)
              ],
              tl: /* [] */0
            });
}

function decode$5(param) {
  var match = param.workerShiftUpdatedByBusiness;
  if (match === undefined) {
    return ;
  }
  var match$1 = match.workerShift;
  if (match$1 !== undefined) {
    return WebTypes_Shift.tToR(match$1.shift);
  }
  
}

var Definition$5 = {
  Raw: Raw$5,
  query: query$5,
  parse: parse$5,
  serialize: serialize$5,
  serializeVariables: serializeVariables$5,
  makeVariables: makeVariables$5,
  variables: variables$5,
  decode: decode$5
};

var include$5 = Apollo.CreateSubscription({
      Raw: Raw$5,
      query: query$5,
      variables: variables$5,
      parse: parse$5,
      decode: decode$5
    });

var WorkerShiftUpdated_graphQLSubscriptionAST = include$5.graphQLSubscriptionAST;

var WorkerShiftUpdated_subscribe = include$5.subscribe;

var WorkerShiftUpdated = {
  Definition: Definition$5,
  graphQLSubscriptionAST: WorkerShiftUpdated_graphQLSubscriptionAST,
  subscribe: WorkerShiftUpdated_subscribe
};

var Subscription = {
  ShiftCreated: ShiftCreated,
  ShiftUpdated: ShiftUpdated,
  WorkerShiftCreated: WorkerShiftCreated,
  WorkerShiftUpdated: WorkerShiftUpdated
};

exports.GetPayTipsToDos = GetPayTipsToDos;
exports.PayTips = PayTips;
exports.Subscription = Subscription;
/* include Not a pure module */
